import {Component, Input, OnInit} from '@angular/core';
import {PrintInstruction} from "../../../models/print-job";
import { CommonModule, NgForOf } from '@angular/common';
import { LoadingSpinnerComponent } from '../loading-spinner-component';
import {SeparatorComponent} from '../separator.component';
import {TranslateService} from '../../../services/translate.service';

@Component({
  selector: 'app-dossier-viewer',
  standalone: true,
  imports: [
    NgForOf,
    LoadingSpinnerComponent,
    CommonModule,
    SeparatorComponent
  ],
  templateUrl: './dossier-viewer.component.html',
  styleUrls: ['./dossier-viewer.component.css']
})
export class DossierViewerComponent implements OnInit {

  @Input() textSize: string = "";
  @Input() printInstructions: PrintInstruction[] | undefined;

  constructor(protected translate: TranslateService) { }

  ngOnInit(): void {
    this.prepareInstructions();
  }

  getQrImageUrl(data: string): string {
    return `https://steward.heynows.com/qr?content=${encodeURIComponent(data)}&size=320&margin=1`;
  }

  isReviewQr(data: string): boolean {
    return data.includes('/review');
  }

  private prepareInstructions() {
    if(!this.printInstructions) {
      return;
    }
    for (const pi of this.printInstructions) {
      const t = pi.text;
      if (t) {
        if (t.style === "bold") {
          pi.tclass = "dos-bold";
        }
        if (t.fontHeight && t.fontHeight >= 2) {
          pi.tclass = (pi.tclass || '') + ' dos-large';
        }
        if (t.center && (!t.layout || t.layout === "0,1,0")) {
          if (t.center.startsWith("----")) {
            pi.temp = "div";
          } else {
            pi.temp = "center";
          }
        } else {
          if (t.layout === "5,5,8") {
            pi.temp = "row5-5-8";
          } else {
            pi.temp = "row";
          }
        }
        if (t.left === "") { t.left = "&nbsp;"; }
        if (t.center === "") { t.center = "&nbsp;"; }
        if (t.right === "") { t.right = "&nbsp;"; }
        // Hack to fix space indent
        if (t.left?.startsWith("        ")) { t.left = t.left.replace("        ", "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"); }
      }
    }
  }

}
